export default "__VITE_ASSET__d3A$FXvP__"